import api from './apiClient'

export default {
    name: 'locationsApi',
    search: async data => await api.post('location/search', data),
    getLocation: async () => await api.get('location'),
    getCsNoList: async () => await api.get('location/csList'),
    forgetLocation: async () => await api.post('location/forget')
}